import type { ReactNode } from 'react';
import { rangeLabel } from '../../data/format.js';
import type { CreativeDetailScope, DeliveryNode } from '../data/api.js';
import { ChartSection } from '../shared/ChartSection.js';
import { TrendMetricPicker } from '../shared/TrendMetricPicker.js';
import { CreativeTrendChart } from './CreativeTrendChart.js';

interface TrendSectionProps {
  scope: CreativeDetailScope;
  creativeId: string;
  node: DeliveryNode | undefined;
  metricNames: [string] | [string, string];
  availableMetrics: string[];
  onMetricNamesChange: (metricNames: [string] | [string, string]) => void;
}

export function TrendSection({
  scope,
  creativeId,
  node,
  metricNames,
  availableMetrics,
  onMetricNamesChange,
}: TrendSectionProps): ReactNode {
  return (
    <ChartSection
      variant="card"
      title="Trending"
      subtitle={rangeLabel(scope.dateRange)}
      actions={
        <TrendMetricPicker
          availableMetrics={availableMetrics}
          metricNames={metricNames}
          onMetricNamesChange={onMetricNamesChange}
        />
      }
    >
      <CreativeTrendChart
        scope={scope}
        creativeId={creativeId}
        node={node}
        metricNames={metricNames}
      />
    </ChartSection>
  );
}
